import { render, staticRenderFns } from "./ListIklan.vue?vue&type=template&id=974427d4"
import script from "./ListIklan.vue?vue&type=script&lang=js"
export * from "./ListIklan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports